import React, {useMemo} from "react";

import cx from "classnames";

import {SocialProofDetailsItem} from "@components/Menu/SocialProof/interfaces";
import useSocialProofDetails from "@components/Menu/SocialProof/useSocialProofDetails";
import SpriteIcon from "@components/SpriteIcon";

import styles from "./SocialProofDetails.scss";
import {SocialProofDetailsViewType} from "./interfaces";

const SocialProofRibbon = ({
  socialProof,
  isDishDetails,
  className,
}: {
  socialProof: SocialProofDetailsItem;
  isDishDetails?: boolean;
  className?: string;
}): JSX.Element => (
  <div
    className={cx(
      styles.socialProof,
      isDishDetails && styles.dishDetailsWrapper,
      className
    )}
    title={socialProof.longDescription}
  >
    <span className={cx(styles.socialSpriteContainer, styles.ribbonSprite)}>
      <SpriteIcon iconName={socialProof.icon} />
    </span>
    <span className={styles.socialProofDescription}>
      {socialProof.description}
    </span>
  </div>
);

const SocialProofExplanation = ({
  socialProof,
  className,
}: {
  socialProof: SocialProofDetailsItem;
  className?: string;
}): JSX.Element => (
  <div className={cx(styles.socialProofExplanation, className)}>
    <span
      className={cx(styles.socialSpriteContainer, styles.explanationSprite)}
    >
      <SpriteIcon iconName={socialProof.icon} />
    </span>
    <div className={styles.socialProofExplanationDescription}>
      {socialProof.longDescription}
    </div>
  </div>
);

export default function SocialProofDetails({
  itemId,
  detailsType,
  isDishDetails,
  className,
}: {
  itemId: number;
  detailsType: SocialProofDetailsViewType;
  isDishDetails?: boolean;
  className?: string;
}): JSX.Element {
  const {getSocialProofDetails} = useSocialProofDetails();
  const socialProof = useMemo(() => {
    if (itemId && getSocialProofDetails) {
      return getSocialProofDetails(itemId);
    }
  }, [itemId, getSocialProofDetails]);

  const components = {
    [SocialProofDetailsViewType.Explanation]: SocialProofExplanation,
    [SocialProofDetailsViewType.Ribbon]: SocialProofRibbon,
  };

  const SocialProofComponent = components[detailsType];

  if (!socialProof) {
    return <></>;
  }

  return (
    <SocialProofComponent
      socialProof={socialProof}
      isDishDetails={isDishDetails}
      className={className}
    />
  );
}
